import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AuthoritiesPageRoutingModule } from './authorities-routing.module';

import { AuthoritiesPage } from './authorities.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AuthoritiesPageRoutingModule
  ],
  declarations: [AuthoritiesPage]
})
export class AuthoritiesPageModule {}
